export default {
  title: 'Create Event',
  backButton: 'Back to Events',
};
